module.exports = __webpack_public_path__ + "img/plus-sm.4eb3a3c6.svg";